import React from 'react';
import './../app.scss';

export default function Css() {
	return (
		<>
		</>
	);
}